<div class="modal-header col-12">
    <h5 class="modal-title">Yeni Hatırlatma Oluştur</h5>
    <button type="button" class="close" aria-label="Close" (click)="onClose(false)">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body col-12">
    <form [formGroup]="createReminderForm">
        <div class="row">

            <div class="col-xl-5 col-md-6 col-sm-12">
                <label for="kindId">Servis Türü</label>
                <div class="form-group">
                    <ng-select [items]="kinds" formControlName="kindId" placeholder="Servis Türü Seç" bindValue="id"
                        bindLabel="typeName"></ng-select>
                </div>
            </div>

            <div class="col-xl-5 col-md-6 col-sm-12">
                <label class="form-label">CC Mail (opsiyonel)</label>
                <input type="email" class="form-control" formControlName="ccMail">
            </div>

            <div class="col-xl-2 col-md-3 col-sm-12">
                <div class="form-check mt-1">
                    <input type="checkbox" class="form-check-input" id="isActive" formControlName="isActive">
                    <label class="form-check-label" for="isActive">Aktif</label>
                </div>
            </div>

            <div class="col-xl-12 col-md-6 col-sm-12">
                <label class="form-label">Konu Başlığı</label>
                <input type="text" class="form-control"
                    placeholder="Buraya yazılan mailde ilgili konu başlığı olarak gönderilir"
                    formControlName="serviceName" />
            </div>

            <div class="col-12">
                <label class="form-label">Mesaj (opsiyonel)</label>
                <textarea class="form-control" formControlName="message"
                    placeholder="Buradaki mesaj mail gönderiminde tablonun üstünde yer alacaktır"></textarea>
            </div>

            <hr />

            <h6 class="col-12 mt-50">Ayarlar</h6>
            <div formArrayName="createReminderSettingDTOs">
                <div *ngFor="let setting of createReminderSettings.controls; let i = index" [formGroupName]="i"
                    class="row col-12 mb-2">
                    <div class="col-xl-5">
                        <label class="form-label">Kaç Gün Önceden Çalışsın</label>
                        <input type="number" class="form-control" formControlName="daysBefore" />
                    </div>

                    <div class="col-xl-5">
                        <label class="form-label">Günde Kaç Defa</label>
                        <input type="number" class="form-control" formControlName="timesPerDay" />
                    </div>

                    <div class="col-xl-2 d-flex align-items-end">
                        <button type="button" class="btn btn-success mr-1" (click)="addSetting()">+</button>
                        <button type="button" class="btn btn-danger" (click)="removeSetting(i)">-</button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer col-12">
    <button type="button" class="btn btn-secondary" (click)="onClose(false)">İptal</button>
    <button type="button" class="btn btn-primary" [disabled]="createReminderForm.invalid"
        (click)="save()">Kaydet</button>
</div>